import { useNavigate } from 'react-router-dom';

const HeroSection = () => {
  const navigate = useNavigate();

  return (
    <section className="relative overflow-hidden bg-white dark:bg-gray-900 pt-12 pb-20 lg:pt-24 lg:pb-32 transition-colors duration-300">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12 lg:mb-20">
          <div className="inline-flex items-center rounded-full bg-pink-50 dark:bg-pink-900/20 px-4 py-1.5 mb-6 border border-pink-100 dark:border-pink-800">
            <span className="text-xs sm:text-sm font-semibold text-pink-600 dark:text-pink-400">
              Works with Instagram & Facebook, No website needed
            </span>
          </div>
          <h1 className="text-3xl lg:text-5xl font-black tracking-tight text-gray-900 dark:text-white mb-6 leading-tight">
            Every <span className="text-transparent bg-clip-text bg-gradient-to-r from-purple-600 to-pink-500">Instagram Reel</span> <br className="hidden lg:block" /> Can Be a Sale
          </h1>
          <p className="max-w-xl mx-auto text-base lg:text-lg text-gray-600 dark:text-gray-400 mb-10">
            No website. No complicated setup. <br className="hidden sm:block" />
            Just post your Reel on Instagram & Facebook, and let ReelTale handle the rest — from comments to payments to delivery.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <button 
              onClick={() => navigate('/signup')}
              className="w-full sm:w-auto px-5 py-3 text-base lg:text-lg font-bold text-white bg-gradient-to-r from-purple-600 to-indigo-600 rounded-full hover:shadow-lg transition-all transform hover:-translate-y-1"
            >
              Start for free →
            </button>
            <button 
              onClick={() => document.getElementById('how-it-works')?.scrollIntoView({ behavior: 'smooth' })}
              className="w-full sm:w-auto px-5 py-3 text-base lg:text-lg font-bold text-gray-700 dark:text-gray-200 bg-white dark:bg-gray-800 border-2 border-gray-100 dark:border-gray-700 rounded-full hover:border-gray-200 dark:hover:border-gray-600 transition-all transform hover:-translate-y-1"
            >
              See how it works
            </button>
          </div>
        </div>

        <div className="relative mx-auto max-w-5xl">
          <div className="rounded-[2rem] overflow-hidden bg-gradient-to-b from-gray-900 to-black p-4 lg:p-5 shadow-2xl border border-white/10">
            <div className="flex animate-hero-marquee space-x-4 lg:space-x-5 whitespace-nowrap">
              {[0, 1, 2, 3, 4, 5, 6, 7, 0, 1, 2, 3, 4, 5, 6, 7].map((num, i) => (
                <div key={i} className="inline-block w-32 lg:w-48 flex-shrink-0 transition-transform hover:scale-105 duration-500">
                  <img 
                    src={`/assets/revamp/hero-section/Group 168655716${num}.png`} 
                    alt={`Reel ${num}`} 
                    className="w-full h-auto object-contain"
                  />
                </div>
              ))}
            </div>
          </div>
          
          <style dangerouslySetInnerHTML={{ __html: `
            @keyframes hero-marquee {
              0% { transform: translateX(0); }
              100% { transform: translateX(-50%); }
            }
            .animate-hero-marquee {
              display: inline-flex;
              animation: hero-marquee 50s linear infinite;
              height: auto;
              max-height: 400px;
            }
            .animate-hero-marquee:hover {
              animation-play-state: paused;
            }
          `}} />

          {/* Decorative elements */}
          <div className="absolute -top-12 -right-12 w-64 h-64 bg-purple-500/20 rounded-full mix-blend-multiply filter blur-3xl opacity-30 animate-pulse"></div>
          <div className="absolute -bottom-12 -left-12 w-64 h-64 bg-pink-500/20 rounded-full mix-blend-multiply filter blur-3xl opacity-30 animate-pulse"></div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
